import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { env } from '@/config/env'
import { authEvents } from '@/lib/auth/authEvents'
import { tokenStorage } from '@/lib/auth/tokenStorage'

export interface ApiError {
  message: string
  statusCode: number
  errors?: Record<string, string[]>
}

const httpClient = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
})

httpClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = tokenStorage.getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

httpClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message?: string }>) => {
    if (error.response?.status === 401) {
      authEvents.emit('unauthorized')
    }

    const apiError: ApiError = {
      message: error.response?.data?.message || error.message || 'An unexpected error occurred',
      statusCode: error.response?.status || 500,
    }

    return Promise.reject(apiError)
  }
)

export { httpClient }
